import { render } from "./StudySpace.vue?vue&type=template&id=74d33126"
import script from "./StudySpace.vue?vue&type=script&lang=js"
export * from "./StudySpace.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__